import { render, staticRenderFns } from "./YImage.vue?vue&type=template&id=4149754f"
import script from "./YImage.vue?vue&type=script&lang=js"
export * from "./YImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports